import React from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { FieldRenderProps } from '@progress/kendo-react-form';
// @ts-ignore
import styles from './form.module.scss';

interface CustomInputProps extends FieldRenderProps {
  label: any,
  required: boolean
}

export const CustomInput = (props: CustomInputProps) => {
  return (
    <Input
      className={`${props.className ?? ''}${props.readOnly ? styles.readOnly : ''}`}
      label={props.label}
      value={props.value || ''}
      onChange={props.onChange}
      required={props.required}
      valid={!props.required || !props.visited || props.value}
      onBlur={props.onBlur}
      readOnly={props.readOnly}
      maxLength={props.maxLength}
      style={props.style}
    />
  );
};
